// @flow
import type { ModalType } from 'containers/ModalRoot';

type ShowModalAction = {
  type: 'MODAL_SHOW',
  payload: {
    type: string,
    props: Object
  }
};
type HideModalAction = {
  type: 'MODAL_HIDE'
};

export type Action = ShowModalAction | HideModalAction;

export const showModal = (
  type: ModalType,
  props: Object = {}
): ShowModalAction => ({
  type: 'MODAL_SHOW',
  payload: {
    type,
    props
  }
});

export const hideModal = (): HideModalAction => ({
  type: 'MODAL_HIDE'
});
